var $7b9178a6cd97f028$exports = {};
{
    const sw = "service-worker.js"; // Required because parcel will not recognize this as a file and will throw during build.
    if ("serviceWorker" in navigator) navigator.serviceWorker.register(sw).catch((err)=>{
        console.error(err);
    });
}

//# sourceMappingURL=index.bb1ce697.js.map
